module.exports = __webpack_public_path__ + "static/media/Artboard–5@2x.00e244e0.png";